
import React, { Fragment, useEffect, useState, useMemo } from 'react';
import { connect } from 'react-redux';
import { push as pushToHistory } from 'connected-react-router';

// Components

import AssigneesList from './AssigneesList';
import AssigneesSearch from './AssigneesSearch';
import ManageAttributes from './ManageAttributes';

// ActionCreators

import { assigneesActionCreators } from '../../../actions/ticketMgmtPortal/ticketMgmtPortalActionCreators';

// Constants

import { adjustSearchInputsDefaultValues } from '../../../utils/miscellaneous/adjustSearchInputsDefaultValues';

// Selectors

import { getHistory } from '../../../reducers/appReducer';


const ExchangeAssigneesManagement = props => {

    const VIEWS = {
        SEARCH_AND_LIST: 'SEARCH_AND_LIST',
        MANAGE_ATTRIBUTES: 'MANAGE_ATTRIBUTES'
    };

    const {
        getAssignees,
        getWorkgroupsTagsList,
        history,
        pushToHistory,
        updateAssigneeAttributes
    } = props;

    const [ lists, updateLists ] = useState({
        roles: [],
        tags: [],
        workgroups: []
    });

    const initialValues = adjustSearchInputsDefaultValues(history);

    const [ assignee, changeCurrentAssignee ] = useState(null);
    const [ assignees, updateAssignees ] = useState([]);
    const [ searchValues, updateSearchValues ] = useState(initialValues);
    const [ view, toggleView ] = useState(VIEWS.SEARCH_AND_LIST);

    useEffect(() => {
        getWorkgroupsTagsList()
            .then(lists => {
                if(lists) {
                    updateLists(lists);
                }
            });
    }, [  ]);

    useEffect(() => {
        toggleView(assignee === null ? VIEWS.SEARCH_AND_LIST : VIEWS.MANAGE_ATTRIBUTES);
    }, [ assignee ]);

    const currentAssignee = useMemo(
        () => assignees && assignees.find(a =>  a.id === assignee),
        [ assignees, assignee ]
    );

    const getView = () => {
        switch(view) {
            case VIEWS.SEARCH_AND_LIST:
                return (
                    <Fragment>
                        <AssigneesSearch
                            { ...{
                                getAssignees,
                                history,
                                lists,
                                pushToHistory,
                                searchValues,
                                updateAssignees,
                                updateSearchValues
                            } }
                        />
                        <AssigneesList
                            { ...{
                                assignees,
                                changeCurrentAssignee
                            } }
                        />
                    </Fragment>
                );
            case VIEWS.MANAGE_ATTRIBUTES:
                return (
                    <ManageAttributes
                        { ...{
                            assignees,
                            currentAssignee,
                            changeCurrentAssignee,
                            lists,
                            updateAssignees,
                            updateAssigneeAttributes
                        } }
                    />
                );
        }
    };

    return (
        <Fragment>
            { getView() }
        </Fragment>

    );
};

const mapStateToProps = state => ({
    history: getHistory(state)
});

export default connect(
    mapStateToProps,
    {
        ...assigneesActionCreators,
        pushToHistory
    }
)(ExchangeAssigneesManagement);